import { render } from "./TituloServicioNew.vue?vue&type=template&id=d343f45e&scoped=true"
import script from "./TituloServicioNew.vue?vue&type=script&lang=js"
export * from "./TituloServicioNew.vue?vue&type=script&lang=js"

import "./TituloServicioNew.vue?vue&type=style&index=0&id=d343f45e&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d343f45e"]])

export default __exports__